import StoredCardOption from './StoredCardOption';
export default StoredCardOption;